export const sectorCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Name',
      form_title: 'Market Sector',
      section: [
        {
          name: 'name',
          placeholder: 'Enter Sector Name',
          input: 'input',
          rules: [
            {
              required: true,
              message: 'Sector name is required',
            },
          ],
        },
        {
          name: 'network_radius',
          input: 'inputNumber',
          max: 1000,
          min: 0,
          precision: 0,
          placeholder: 'Network Radius (miles)',
          rules: [
            {
              required: false,
            },
          ],
        },
        {
          name: 'trailer_config',
          input: 'select',
          options: createSelectOptions.trailer_configs,
          type: 'single',
          placeholder: 'Enter trailer config',
        },
      ],
    },
  ]
}
